import { ClassName } from '@boxcryptor-web/shared/class-name';
import * as React from 'react';
import { ExternalLink } from './ExternalLink';
import { InternalLink, InternalLinkProps } from './InternalLink';

type Link = ExternalLink | InternalLink;
const isInternalLinkProps = (props: LinkProps): props is InternalLinkProps => (props as InternalLinkProps).to !== undefined;

export type LinkProps = ClassName<{ children: React.ReactNode } & Link>;
export const Link: React.FC<LinkProps> = (props) =>
  isInternalLinkProps(props) ? <InternalLink {...props} /> : <ExternalLink {...props} />;
